/**
 * Ant Design's own strings (modal buttons, empty states) in the app's four
 * languages. Exhaustive over the Language union on purpose: adding a fifth
 * language without wiring its antd pack becomes a typecheck failure here
 * rather than an English "OK" in a Chinese interface.
 */

import type { Locale } from 'antd/es/locale'
import enUS from 'antd/es/locale/en_US'
import esES from 'antd/es/locale/es_ES'
import zhCN from 'antd/es/locale/zh_CN'
import zhTW from 'antd/es/locale/zh_TW'
import type { Language } from '../../i18n/i18n'

const LOCALES: Record<Language, Locale> = {
  en: enUS,
  es: esES,
  zh_cn: zhCN,
  zh_tw: zhTW,
}

export function antdLocaleFor(lang: Language): Locale {
  return LOCALES[lang]
}
